/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchProviderDirectoryResponse } from './SearchProviderDirectoryResponse';
import {
    SearchProviderDirectoryResponseFromJSON,
    SearchProviderDirectoryResponseFromJSONTyped,
    SearchProviderDirectoryResponseToJSON,
    SearchProviderDirectoryResponseToJSONTyped,
} from './SearchProviderDirectoryResponse';

/**
 * 
 * @export
 * @interface SearchProviderDirectory200Response
 */
export interface SearchProviderDirectory200Response {
    /**
     * 
     */
    data?: SearchProviderDirectoryResponse;
}

/**
 * Check if a given object implements the SearchProviderDirectory200Response interface.
 */
export function instanceOfSearchProviderDirectory200Response(value: object): value is SearchProviderDirectory200Response {
    return true;
}

export function SearchProviderDirectory200ResponseFromJSON(json: any): SearchProviderDirectory200Response {
    return SearchProviderDirectory200ResponseFromJSONTyped(json, false);
}

export function SearchProviderDirectory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProviderDirectory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SearchProviderDirectoryResponseFromJSON(json['data']),
    };
}

export function SearchProviderDirectory200ResponseToJSON(json: any): SearchProviderDirectory200Response {
    return SearchProviderDirectory200ResponseToJSONTyped(json, false);
}

export function SearchProviderDirectory200ResponseToJSONTyped(value?: SearchProviderDirectory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SearchProviderDirectoryResponseToJSON(value['data']),
    };
}

